import { render, staticRenderFns } from "./SMSEnrollment.vue?vue&type=template&id=e31a22f4&"
import script from "./SMSEnrollment.vue?vue&type=script&lang=js&"
export * from "./SMSEnrollment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports